import React, { Fragment } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Menu, Transition } from "@headlessui/react";
import { GlobeAltIcon, CheckIcon } from "@heroicons/react/24/solid";
import { manageTicketCount, cancelPromo } from "@ticketsaction";
import { classNames } from "@utilscommon";
import { CDN_BASE_IMAGES_URL } from "@constant";
import { displayDateInBrowserFormat } from "@datehandle";
import LocaleStrings from "@language";

const Header = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { eventData, eventLanguages } = props;
  // console.log("eventData :- ", eventData);
  let eventIcon = `${CDN_BASE_IMAGES_URL}/${eventData?.eventicon}`;
  let eventdate = "-";
  if (eventData?.eventstartdate && eventData?.eventenddate) {
    let startDate = eventData?.eventstartdate;
    let endDate = eventData?.eventenddate;

    if (eventData?.eventstartdatem1 === eventData?.eventenddate) {
      startDate = displayDateInBrowserFormat(eventData?.eventstartdate, "P");
      eventdate = startDate;
    } else {
      startDate = displayDateInBrowserFormat(eventData?.eventstartdate, "P");
      endDate = displayDateInBrowserFormat(eventData?.eventenddate, "P");
      eventdate = startDate + " - " + endDate;
    }
  }
  let path = location?.pathname;
  let source = location?.state?.source ?? "";
  let ticketAssignPage = path.includes("ticketorder");
  let lang = LocaleStrings.getLanguage();

  const geToHome = () => {
    let param = location.search;
    // Clear the selected ticket, if currency changed
    props.manageTicketCount([]);

    // Clear the promo code, if currency changed
    props.cancelPromo({});
    if (path === "/thank-you") {
      if (source === "registration") {
        navigate(`/register${param}`);
      } else if (source === "ticket") {
        navigate(`/tickets${param}`);
      }
    } else {
      navigate(`/tickets${param}`);
    }
  };

  const handleLang = (ln) => {
    let param = new URLSearchParams(location.search);

    param.set("lang", ln.toString()); // Set new or update existing param
    // console.log("param :- ", param);

    navigate(`?${param.toString()}`, { replace: true });

    window.location.reload();
  };

  return (
    <header
      id="MAIN_HEADER"
      className={classNames("main-header pt-8 pb-24 px-4 lg:px-6 xl:px-0")}
    >
      <div className="mx-auto max-w-5xl flex items-center justify-between">
        <div
          className={`custom-item-vcenter space-x-3 w-fit ${
            ticketAssignPage || (path === "/thank-you" && source !== "")
              ? "cursor-pointer"
              : ""
          }`}
          onClick={
            ticketAssignPage || (path === "/thank-you" && source !== "")
              ? geToHome
              : null
          }
        >
          <img
            className="event-icon rounded-lg"
            src={eventIcon}
            alt="eventicon"
          />

          <div>
            <div className="custom-text-white-2xl-bold">
              {eventData?.eventname}
            </div>
            <div className="custom-text-white-md-normal">{eventdate}</div>
            <div className="custom-text-white-md-normal">
              {eventData?.country}
            </div>
          </div>
        </div>

        <div>
          {eventLanguages.length > 1 ? (
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button className="text-primary">
                  <GlobeAltIcon className="h-7 w-7" aria-hidden="true" />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="origin-top-right overflow-hidden flex flex-col absolute right-0 w-48 rounded-md shadow-xl bg-white ring-1 ring-black ring-opacity-5">
                  {eventLanguages.map((element) => {
                    return (
                      <Menu.Item key={`lang_key_${element.languagekey}`}>
                        {({ active }) => (
                          <div
                            onClick={() => handleLang(element.languagekey)}
                            className={classNames(
                              active || lang === element.languagekey
                                ? "bg-blue-50"
                                : "",
                              "custom-text-primary-md-medium px-4 py-2 cursor-pointer flex justify-between items-center gap-2"
                            )}
                          >
                            <span>{element.languagetext}</span>
                            {lang === element.languagekey ? (
                              <CheckIcon className="w-5 h-5" />
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </Menu.Item>
                    );
                  })}
                </Menu.Items>
              </Transition>
            </Menu>
          ) : (
            ""
          )}
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    deviceSize: { isMobile: false },
    eventData: state.eventData,
    eventLanguages: state.eventLanguages,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ manageTicketCount, cancelPromo }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
